import { modifier } from 'ember-modifier';
export default modifier(element => {
  // @ts-ignore: Current TS version doesn't have autofocus typed for HTMLElement
  element.autofocus = true;
  element.focus();
  return () => {};
});